import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { connect } from 'react-redux';
import { getThreadState } from '../../selectors';
const mapStateToProps = (state, { commentableTypeId, commentableItemId, parentId })=>{
    const threadState = getThreadState(state, commentableTypeId, commentableItemId, parentId);
    return _object_spread_props(_object_spread({}, threadState), {
        itemCount: threadState.items.length
    });
};
export default connect(mapStateToProps);
